import { metadataNodeFields, type CorpusNode, type TrashEntry } from './model'
import { flattenNodes } from './treeUtils'

// The Trash: how long it keeps things, entries rebuilt from the cloud's
// tombstones, and the page files that move with an entry.

export const TRASH_RETENTION_DAYS = 30
export const TRASH_RETENTION_MS = TRASH_RETENTION_DAYS * 24 * 60 * 60 * 1000

export function trashEntriesFromRemote(nodes: any[]): TrashEntry[] {
  const deleted = nodes.filter((node) => node.deletedAt)
  const nodeMap = new Map<string, CorpusNode>()
  for (const item of deleted) {
    const subtype: CorpusNode['subtype'] = item.subtype || (item.type === 'folder' ? 'folder' : 'page')
    nodeMap.set(item.id, {
      id: item.id,
      name: item.name || 'Untitled',
      subtype,
      position: item.position || 0,
      hlcTimestamp: item.hlcTimestamp || 0,
      icon: item.icon ?? null,
      color: item.color ?? null,
      ...metadataNodeFields(item.metadata),
      children: [],
      ...(subtype !== 'desk' ? { expanded: true } : {}),
    })
  }

  const entries: TrashEntry[] = []
  for (const item of deleted) {
    const node = nodeMap.get(item.id)!
    if (item.parentId && nodeMap.has(item.parentId)) {
      nodeMap.get(item.parentId)!.children!.push(node)
    } else {
      entries.push({
        node,
        originalParentId: item.parentId ?? null,
        originalIndex: 0,
        deletedAt: Date.parse(item.deletedAt) || Date.now(),
      })
    }
  }
  return entries
}

export function moveTrashEntryFiles(entry: TrashEntry, action: 'trashPage' | 'restorePage'): void {
  for (const { node } of flattenNodes([entry.node])) {
    if (node.subtype === 'page') {
      void (window as any).api?.[action]?.(node.id).catch((error: unknown) => {
        console.warn(`Failed to ${action === 'trashPage' ? 'trash' : 'restore'} remote page ${node.id}:`, error)
      })
    }
  }
}
